import { render, staticRenderFns } from "./IconNextArrow.vue?vue&type=template&id=d12cab70"
import script from "./IconNextArrow.vue?vue&type=script&lang=js"
export * from "./IconNextArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports